import { InfoBalloon } from '../components/InfoBalloon'
import { HELP_CONTENT, type HelpContentId } from './helpContent'

export interface HelpBalloonProps {
  /** Stable section-registry key — see `HELP_CONTENT` (`helpContent.ts`). */
  id: HelpContentId
  /** Panel horizontal anchor — pass `end` when the trigger sits near a container's right edge. */
  align?: 'start' | 'end' | undefined
}

/**
 * The call-site convenience wrapper every section heading uses: `<HelpBalloon id="tab.credit" />`
 * rather than every screen re-reading `HELP_CONTENT` and spreading `title`/`body` onto `InfoBalloon`
 * itself. Keeps the registry the single place copy can drift from, and the component the single
 * place the interaction/a11y contract lives.
 */
export function HelpBalloon({ id, align }: HelpBalloonProps) {
  const entry = HELP_CONTENT[id]
  return <InfoBalloon title={entry.title} body={entry.body} align={align} />
}
